'use client';
import React from 'react';

const WetGlobalStyles: React.FC = () => (
  <style jsx global>{`
    body {
      font-family: 'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
      background-color: #0d1b2a;
      color: #ffffff;
      scroll-behavior: smooth;
    }
    :root { --accent-color: #4fd1c5; --accent-2: #38b2ac; }

    /* --- Added Rules for Anchor Offset --- */
    :root { --anchor-offset: 96px; }        /* tune to your header height */
    @media (min-width: 1024px) {
      :root { --anchor-offset: 112px; }     /* optional desktop tweak */
    }
    /* Any anchored section gets this offset */
    .anchor-target { scroll-margin-top: var(--anchor-offset); }
    /* --- End of Added Rules --- */

    @keyframes fadeInRippleText {
      0% { opacity: 0; letter-spacing: -0.5em; filter: blur(12px); }
      100% { opacity: 1; letter-spacing: normal; filter: blur(0); }
    }
    @keyframes wave-animate { 0% { background-position-x: 0; } 100% { background-position-x: 1000px; } }
    @keyframes wave-animate2 { 0% { background-position-x: 0; } 100% { background-position-x: -1000px; } }
    .glow-button {
      background-image: linear-gradient(to right, var(--accent-color), #14b8a6);
      box-shadow: 0 0 6px var(--accent-color), 0 0 14px rgba(20,184,166,.5);
      transition: transform .25s ease, box-shadow .25s ease, filter .25s ease;
    }
    .glow-button:hover { transform: translateY(-1px) scale(1.02); box-shadow: 0 0 10px var(--accent-color), 0 0 22px rgba(20,184,166,.6); }
    .fade-up { opacity: 0; transform: translateY(30px); transition: opacity .6s ease-out, transform .6s ease-out; }
    .fade-up.visible { opacity: 1; transform: translateY(0); }
    .comparison-slider { position: relative; overflow: hidden; border-radius: .5rem; }
    .comparison-slider .after-image {
      position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover;
      clip-path: polygon(0 0, 50% 0, 50% 100%, 0 100%);
    }
    .comparison-slider input[type=range]{
      -webkit-appearance:none; appearance:none; position:absolute; inset:0; width:100%; height:100%;
      background:transparent; margin:0; cursor: col-resize;
    }
    .comparison-slider input[type=range]::-webkit-slider-thumb{ -webkit-appearance:none; width:4px; height:100%; background: var(--accent-color); }
    .comparison-slider input[type=range]::-moz-range-thumb{ width:4px; height:100%; background: var(--accent-color); border:none; border-radius:0; }
    .shine-button {
  position: relative;
  overflow: hidden;
  isolation: isolate;
}

/* 2. The shine pseudo-element itself.
      We create a tall, angled, semi-transparent gradient.
*/
.shine-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%; /* Start off-screen to the left */
  width: 75%;
  height: 100%;

  /* The angled white sheen */
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4), /* A 40% white sheen */
    transparent
  );
  
  /* The angle of the sheen */
  transform: skewX(-30deg);
  
  /* The animation properties */
  animation-name: shine-sweep;
  animation-duration: 4s; /* Total duration of one loop */
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}

/* 3. The animation keyframes.
      - 0%: The sheen is off-screen to the left.
      - 25%: The sheen has swept all the way across.
      - 100%: The sheen stays off-screen to the right.
      This makes it "Shine" for 1 second, then "Wait" 3 seconds.
*/
@keyframes shine-sweep {
  0% {
    left: -100%;
  }
  25% {
    left: 150%;
  }
  100% {
    left: 150%;
  }
}

    
  `}</style>
);

export default WetGlobalStyles;